import { ForgetPassword } from "@widgets/auth/ui/forget-password/forget-password";

export const ForgetPasswordPage = () => <ForgetPassword/>